// extracted by css-extract-rspack-plugin
export default {"breadcrumbs":"p4lU9"};